import classNames from 'clsx';
import React from 'react';

import LoadingIndicator from '@swf/components/LoadingIndicator/LoadingIndicator';

import styles from './Loader.scss';

interface Props {
  loading: boolean;
  className?: string;
}

const Loader: React.FC<React.PropsWithChildren<Props>> = ({ loading, children, className }) => (
  <LoadingIndicator
    className={classNames(styles.container, className)}
    loading={loading}
    variant="light"
  >
    {children}
  </LoadingIndicator>
);

export default Loader;
